/* global GLOBALS */
import 'bootstrap/js/dropdown';
import 'bootstrap/js/modal';

import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'utils/global_widgets';
import 'utils/global_events';
import 'views/video';

import AccountProfile from 'views/account-profile';
import CoachHubView from 'views/coachhub';
import DailyTrackerView from 'views/daily_tracker';
import ExercisesView from 'views/exercises';
import LoadingView from 'core/views/loading';
import NotificationsView from 'views/notifications';
import PasswordResetView from 'views/password_reset';
import YourChartView from 'views/your_chart';
import YourPlanView from 'views/your_plan';


export default Backbone.Router.extend({
  routes: {
    'accounts/': 'accounts',
    'accounts/password_reset/': 'passwordReset',
    'accounts/password_reset/done/': 'passwordReset',
    'accounts/register/notifications/': 'registerNotifications',
    'tracker/coach-connect/': 'coachConnect',
    'tracker/daily-tracker/': 'dailyTracker',
    'tracker/exercises/': 'exercises',
    'tracker/your-chart/': 'yourChart',
    'tracker/your-chart/#type/:chartType': 'yourChart',
    'tracker/your-chart/type/:chartType': 'yourChart',
    'tracker/your-plan/': 'yourPlan',
    'tracker/your-plan/:screenerSlug/': 'yourPlan',
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.mobile = options.mobile;

    if (GLOBALS.IS_REAL_USER) {
      new AccountProfile({ el: $('#profileModal') }).render();
    }

    // Native routes, regexes must be added this way
    this.route(/^.*?\/accounts-password_reset.html$/, 'passwordReset');
    this.route(/^.*?\/accounts-password_reset-done.html$/, 'passwordReset');
    this.route(/^.*?\/tracker-daily-tracker.html$/, 'dailyTracker');
    this.route(/^.*?\/tracker-exercises.html$/, 'exercises');
    this.route(/^.*?\/mos-tracker-daily-tracker.html$/, 'dailyTracker');
    this.route(/^.*?\/mos-tracker-exercises.html$/, 'exercises');
  },

  accounts: function () {
    new NotificationsView({ el: $('#account') }).render();
  },

  passwordReset: function () {
    new PasswordResetView({ el: $('#register-form') });
  },

  registerNotifications: function () {
    new NotificationsView({ el: $('#register-notifications-form') }).render();
  },

  coachConnect: function () {
    new CoachHubView({ el: $('#coachhub') });
  },

  dailyTracker: function () {
    var loadingView = new LoadingView({ el: $('body') });
    loadingView.show();
    new DailyTrackerView({ el: $('#wrap'), loadingView: loadingView }).render();
  },

  exercises: function () {
    new ExercisesView({ el: $('#top-content') }).render();
  },

  yourChart: function (chartType) {
    chartType = chartType || 'week';
    new YourChartView({
      el: $('#wrap'),
      chartType: chartType,
      controller: this
    }).render();
  },

  yourPlan: function () {
    new YourPlanView({ el: $('#top-content') }).render();
  }
});



// WEBPACK FOOTER //
// ./static/js/controllers/moodhacker.js